import { render, staticRenderFns } from "./AddQuestionCard.vue?vue&type=template&id=71c269a0&scoped=true&"
import script from "./AddQuestionCard.vue?vue&type=script&lang=js&"
export * from "./AddQuestionCard.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionCard.vue?vue&type=style&index=0&id=71c269a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c269a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtnToggle,VCard,VIcon,VTooltip})
